// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, xScreen } from "@awc/XDL/Utilities";
import { autocompleteCategoriesStyles } from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import { css } from "styled-components";

autocompleteCategoriesStyles.link = {
    typographyProps: {
        ellipsis: true,
        css: css`
            &&& {
                text-align: left;
                margin: 5px 0;
                color: ${color("common.ui14")};
            }
        `,
    },
    css: css`
        width: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 270px;
        ${xScreen("lte", "md")} {
            max-width: 394px;
        }
    `,
};

autocompleteCategoriesStyles.autocompleteCategoriesColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 300px;
        ${xScreen("lte", "md")} {
            width: 394px;
        }
    `,
};

autocompleteCategoriesStyles.categoryItemText = {
    ellipsis: true,
    css: css`
        &&&& {
            width: 100%;
            text-align: left;
            cursor: pointer;
            &:hover [class*="autocomplete-categories-item-link"],
            &:hover [class*="autocomplete-categories-item-link"] * {
                color: ${color("common.ui8")};
            }
        }
    `,
};
